const portraitServices = [
    { id: 12, name: 'Photography - Portrait' },
    { id: 17, name: 'Photography - Portrait 2' },
    { id: 29, name: 'Photography - Eco' },
    { id: 53, name: 'Content Direct Gallery' },
    { id: 61, name: 'Content Direct Gallery One Provider' },
  ]
  
  export default portraitServices
  